import React, { FC, useCallback } from 'react';
import { Box } from '@wix/design-system';
import { MediaUpload } from 'components/MediaUpload/MediaUpload';
import styles from '../CreateProductStep.scss';
import { useProductStore } from 'stores/product';

export const CreateProductStepMedia: FC = () => {
  const productImages = useProductStore((state) => state.productImages);
  const setProductImages = useProductStore((state) => state.setProductImages);
  const isMediaLoading = useProductStore((state) => state.isMediaLoading);

  const onRemoveClicked = useCallback(
    (index: number) => {
      const next = [...productImages];
      next.splice(index, 1);
      setProductImages(next);
    },
    [productImages, setProductImages],
  );

  const onFilePicked = useCallback(
    (index: number, file: File) => {
      const fileUrl = URL.createObjectURL(file);
      const next = [...productImages];
      next.splice(index, 1, fileUrl);
      setProductImages(next);
    },
    [productImages, setProductImages],
  );

  return (
    <Box gap="10px">
      {Array.from({ length: 4 }).map((_, index) => {
        const imageUrl = productImages[index];
        return isMediaLoading && !imageUrl ? (
          <div key={index} className={styles.createProductStepMediaSkeleton} />
        ) : (
          <MediaUpload
            key={index}
            imageUrl={imageUrl}
            onRemoveClicked={() => {
              onRemoveClicked(index);
            }}
            onFilePicked={(file) => {
              file && onFilePicked(index, file);
            }}
          />
        );
      })}
    </Box>
  );
};
